import {
  Component,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  inject,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';

import { ButtonDirective } from '../../../ui/button/button/button.directive';
import { SafeHtmlPipe } from '../../pipes/safe-html.pipe';

export interface InfoModalData {
  title?: string;
  text?: string;
  html?: string;
}

@Component({
  selector: 'semeris-info-modal',
  templateUrl: './info-modal.component.html',
  styleUrls: ['./info-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ButtonDirective,
    MatDialogClose,
    SafeHtmlPipe,
  ],
})
export class InfoModalComponent implements OnInit {
  data = inject<InfoModalData>(MAT_DIALOG_DATA);

  ngOnInit(): void {}
}
